<template>
  <div>
    <p><b>Estadísticas</b></p>
    <div class="cuerpo_esta" >
        <div class="row pt-2">
            <div class="col-sm-4">
                <p class="text-center" style="color:orange"><b>{{titulo1}}</b></p>
                <p class="text-center">
                    <font-icon class="icon" icon="handshake"/>
                </p>
                <p class="text-center">{{proyectos}}</p>
            </div>
            <div class="col-sm-4">
                <p class="text-center" style="color:green"><b>{{titulo2}}</b></p>
                <p class="text-center">
                    <font-icon class="icon" icon="donate"/>
                </p>
                <p class="text-center">${{moneda(ingresos)}}</p>
            </div>
            <div class="col-sm-4">
                <p class="text-center" style="color:purple"><b>{{titulo3}}</b></p>
                <p class="text-center">
                    <font-icon class="icon" icon="chart-line"/>
                </p>
                <p class="text-center">{{efect}}%</p>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { globalFunctions } from '@/hooks/globalFunctions'

export default {
name: 'Estadisticas',
mixins: [ globalFunctions ],
props:['idUsr', 'rol'],
data () {
    return { 
        proyectos: '',
        ingresos: '',
        efect: '',
        titulo1: '',
        titulo2: '',
        titulo3: ''
    }
},
methods:{
    getData(){
        let data = {};
        
        if (this.rol == 0 ){
            data = {
                flag: 0,
                id: this.idUsr
            }

            this.titulo1 = 'Proyectos';
            this.titulo2 = 'Ingresos';
            this.titulo3 = 'Efectividad';

        }else{
            data = {
                flag: 1,
                id: this.idUsr
            }

            this.titulo1 = 'Proyectos Adjudicados';
            this.titulo2 = 'Montos Pagados';
            this.titulo3 = 'Efectividad';
        }

        this.axios.post(this.url + 'getEstadisticas.php', data).then((responce) =>{
            if(responce.data.length == 0){
                this.proyectos = 0;
                this.ingresos = 0;
                this.efect = 0; 
            }else {
                this.proyectos = responce.data.cantidad;
                this.ingresos = responce.data.total;
                this.efect = responce.data.efect;
                this.efect = this.efect.toFixed(2);
            }
        })
    }
},
computed:{
    ...mapState(['url'])
},
mounted(){
    this.getData();
}

  
}
</script>

<style scoped>

.icon{
    font-size: 30px;
}

.cuerpo_esta{
    border: 1px solid blue;
}

</style>>




// WEBPACK FOOTER //
// src/components/Estadisticas.vue